// Minimal country-code list for the Phone selector on Create Custom Order
// + any other places that need a country dropdown. Curated to the
// countries Opswarex tenants actually ship from / to (UAE-first, India,
// rest of GCC, US/UK/EU). Add to this list as needed — keep it short
// to avoid a 250-row dropdown.
//
// Each entry: { code: ISO-3166-1 alpha-2, name, dial: e.164 country code }.
export const COUNTRY_CODES = [
  { code: 'AE', name: 'United Arab Emirates', dial: '+971' },
  { code: 'IN', name: 'India', dial: '+91' },
  { code: 'SA', name: 'Saudi Arabia', dial: '+966' },
  { code: 'OM', name: 'Oman', dial: '+968' },
  { code: 'QA', name: 'Qatar', dial: '+974' },
  { code: 'BH', name: 'Bahrain', dial: '+973' },
  { code: 'KW', name: 'Kuwait', dial: '+965' },
  { code: 'EG', name: 'Egypt', dial: '+20' },
  { code: 'TR', name: 'Turkey', dial: '+90' },
  { code: 'GB', name: 'United Kingdom', dial: '+44' },
  { code: 'US', name: 'United States', dial: '+1' },
  { code: 'CA', name: 'Canada', dial: '+1' },
  { code: 'AU', name: 'Australia', dial: '+61' },
  { code: 'DE', name: 'Germany', dial: '+49' },
  { code: 'FR', name: 'France', dial: '+33' },
  { code: 'IT', name: 'Italy', dial: '+39' },
  { code: 'ES', name: 'Spain', dial: '+34' },
  { code: 'NL', name: 'Netherlands', dial: '+31' },
  { code: 'PK', name: 'Pakistan', dial: '+92' },
  { code: 'BD', name: 'Bangladesh', dial: '+880' },
  { code: 'LK', name: 'Sri Lanka', dial: '+94' },
  { code: 'NP', name: 'Nepal', dial: '+977' },
  { code: 'PH', name: 'Philippines', dial: '+63' },
  { code: 'SG', name: 'Singapore', dial: '+65' },
  { code: 'MY', name: 'Malaysia', dial: '+60' },
  { code: 'ID', name: 'Indonesia', dial: '+62' },
  { code: 'TH', name: 'Thailand', dial: '+66' },
];

// Default selector falls back to UAE since the merchant base is
// Wooden Twist (Dubai). Override in pages that have a known
// merchant country in scope.
export const DEFAULT_COUNTRY_CODE = 'AE';

export function getDialByCode(code) {
  const c = COUNTRY_CODES.find((x) => x.code === code);
  return c ? c.dial : '';
}
